type InteractionDetails = Record<string, any>;

type InteractionEvent = {
  type: string;
  details: InteractionDetails;
  count: number;
};

class InteractionTracker {
  private grouped: Record<string, Map<string, { details: InteractionDetails; count: number }>> = {};
  
  private normalizeDetails(details: InteractionDetails): InteractionDetails {
    const normalized: InteractionDetails = {};
    Object.keys(details).sort().forEach((key) => {
        normalized[key] = String(details[key]);
      });
    return normalized;
  }

  private getKey(details: InteractionDetails): string {
    return JSON.stringify(this.normalizeDetails(details));
  }

  trackEvent(type: string, details: InteractionDetails = {}) {
    const normalizedDetails = this.normalizeDetails(details);
    const key = this.getKey(normalizedDetails);
    if (!this.grouped[type]) {
      this.grouped[type] = new Map();
    }
    const existing = this.grouped[type].get(key);
    if (existing) {
      existing.count += 1;
    } else {
      this.grouped[type].set(key, { details: normalizedDetails, count: 1 });
    }
  }

  getFlatEvents(): InteractionEvent[] {
    return Object.entries(this.grouped).flatMap(([type, typeMap]) =>
      Array.from(typeMap.values()).map(({ details, count }) => ({
        type,
        details,
        count,
      }))
    );
  }

  clearEvents() {
    this.grouped = {};
  }
}

export const tracker = new InteractionTracker();
 